import React, {useContext, useEffect, useState} from 'react';

const Context = React.createContext({
  landingURL: '',
});

const LandingURLProvider = ({children}) => {
  const [landingURL, setLandingURL] = useState('');

  useEffect(() => {
    setLandingURL(window.location.href);
  }, []);

  return <Context.Provider value={{landingURL}}>{children}</Context.Provider>;
};

const LandingURLProviderWrapper = ({children}) => {
  return <LandingURLProvider>{children}</LandingURLProvider>;
};

export function useLandingURL() {
  const context = useContext(Context);

  return {
    landingURL: context.landingURL,
  };
}

export default {
  Context,
  Consumer: Context.Consumer,
  Provider: LandingURLProviderWrapper,
};
